import { ApolloError, gql, useMutation } from "@apollo/client";
import { 
  BusinessOnboardingStepOneMutationMutation, 
  BusinessOnboardingStepOneMutationMutationVariables 
} from "../../../../../schemaTypes";
import { NormalizedErrorMap } from "../../../../../types/NormalizedErrorMap";
import { normalizeErrors } from "../../../../../utils/normalizeErrors";

export const businessOnboardingStepOneMutation = gql`
  mutation BusinessOnboardingStepOneMutation(
    $businessName: String!
    $businessType: String!
    $regCountry: String!
    $businessRegNumber: String!
    $taxId: String
    $address: String!
    $addressAlt: String
    $city: String!
    $country: String!
    $postcode: String
  ) {
    businessOnboardingStepOne(
      businessName: $businessName
      businessType: $businessType
      regCountry: $regCountry
      businessRegNumber: $businessRegNumber
      taxId: $taxId
      address: $address
      addressAlt: $addressAlt
      city: $city
      country: $country
      postcode: $postcode
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  onMessage?: (message: string) => void;
  children: (data: {
    submit: (
      values: BusinessOnboardingStepOneMutationMutationVariables
    ) => Promise<{
      errors: NormalizedErrorMap | null;
      message?: string;
    }>;
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactElement | null;
}

export const BusinessOnboardingOne: React.FC<Props> = ({
  children,
  onMessage,
}) => {
  const [mutate, { loading, error }] = useMutation<
    BusinessOnboardingStepOneMutationMutation,
    BusinessOnboardingStepOneMutationMutationVariables
  >(businessOnboardingStepOneMutation);

  const submit = async (
    values: BusinessOnboardingStepOneMutationMutationVariables
  ) => {
    try {
      const { data } = await mutate({
        variables: { ...values },
      });

      const errors = data?.businessOnboardingStepOne?.errors
        ? normalizeErrors(data.businessOnboardingStepOne.errors)
        : null;

      if (data?.businessOnboardingStepOne?.message && onMessage) {
        onMessage(data.businessOnboardingStepOne.message);
      }

      return {
        errors,
        message: data?.businessOnboardingStepOne?.message ?? undefined,
      };
    } catch (e: any) {
      return {
        errors: { general: e.message || "Onboarding step one failed. Please try again." },
        message: undefined,
      };
    }
  };

  return children({ submit, loading, error });
};